import React from 'react';

/**
 * =====================================
 * Modal Context
 *
 * Share state between Modal and its subcomponents.
 * =====================================
 * */
export type ScrollStrategy = 'outside' | 'inside';

export interface ModalContextState {
  scrollStrategy: ScrollStrategy;
}

export const ModalContext = React.createContext<ModalContextState | null>(null);

export const useModalContext = () => {
  const context = React.useContext(ModalContext);
  if (!context) {
    throw new Error('useModalContext must be used within a ModalContext');
  }
  return context;
};
